module.exports = __webpack_public_path__ + "static/media/muji outcome3.e328b7a9.png";